window.$ = window.jQuery = require("jquery");
require("slick-carousel");
require("./home");
require("./inspiracoes");
require("./criarmoodboard");
require('./simulator/App');

window.toggleMenu = () => {
    document.body.classList.toggle("_is-menu-open");
};

$("body").on('click', '.close', function () {
    $('.header-message').remove();
});